/**
 * @generated SignedSource<<168226367d87cd5c1ad0549f300d7ac1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type UserMeetingRecapSendTo = "ALL" | "INTERNAL" | "JUST_ME" | "NONE";
import { FragmentRefs } from "relay-runtime";
export type StartAndAutoRecordingControls_viewer$data = {
  readonly account: {
    readonly billingAccount: {
      readonly hasCopilotAddon: boolean;
    };
  };
  readonly hasAccessToCopilot: boolean;
  readonly meetingRecapAutoShareSettings: {
    readonly id: string;
    readonly sendTo: UserMeetingRecapSendTo;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"StreamAutoRecordAutomationConfig_useAutoRecordReason_viewer">;
  readonly " $fragmentType": "StartAndAutoRecordingControls_viewer";
};
export type StartAndAutoRecordingControls_viewer$key = {
  readonly " $data"?: StartAndAutoRecordingControls_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"StartAndAutoRecordingControls_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StartAndAutoRecordingControls_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAccessToCopilot",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserMeetingRecapAutoShareSettings",
      "kind": "LinkedField",
      "name": "meetingRecapAutoShareSettings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sendTo",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "BillingAccount",
          "kind": "LinkedField",
          "name": "billingAccount",
          "plural": false,
          "selections": [
            {
              "alias": "hasCopilotAddon",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "meeting_recorder"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"meeting_recorder\")"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StreamAutoRecordAutomationConfig_useAutoRecordReason_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "cc64531a535b3bcf2cabf444fc618eb1";

export default node;
